import React, { useEffect } from 'react';
import classes from './style.module.scss';
import Modal from '~/app/common/Modal';
import { IssueDetails } from '~/types';
import Header from './Header';
import Form from './Form';
import { useStoreActions, useStoreState } from '~/store';

export interface CloseIssueProps {
    open: boolean
    issueDetails?: IssueDetails
    onSave?: (id: IssueDetails['id']) => void
    onClose: () => void
}

export type CloseIssueComponent = React.FC<CloseIssueProps>;

const CloseIssue = ({ open, issueDetails, onSave, onClose }) => {
    const costCategoryAction = useStoreActions(actions => actions.issue.fetchCostCategories);
    const fetchHPCodesAction = useStoreActions(actions => actions.issue.fetchHPCodes);
    const fetchWorkTypesAction = useStoreActions(actions => actions.issue.fetchWorkTypes);
    const fetchCustomersAction = useStoreActions(actions => actions.issue.fetchCustomers);
    const fetchProjectsAction = useStoreActions(actions => actions.projects.fetch);
    const netWorkStatus = useStoreState(state => state.app.offline.status);
    const issue = useStoreState(state => state.issue.data);
    const projects = useStoreState(state => state.projects.list);
    const hasSimplifiedWorkorderEnabled = useStoreState(state => state.issue.data?.hasSimplifiedWorkorderEnabled ?? false);

    useEffect(() => {
        if(!netWorkStatus && hasSimplifiedWorkorderEnabled) {
            issue.issueDepartmentId && costCategoryAction(issue.issueDepartmentId);
            fetchHPCodesAction();
            fetchWorkTypesAction();
            fetchCustomersAction();
            !projects?.length && fetchProjectsAction();
        }
    }, [costCategoryAction, fetchCustomersAction, fetchHPCodesAction, fetchProjectsAction, fetchWorkTypesAction, hasSimplifiedWorkorderEnabled, issue.issueDepartmentId, netWorkStatus, projects?.length]);
    
    return (
        <>
            <Modal className={classes['closeIssueModel']} open={open} onClose={onClose} position={'bottom'}>
                <Header />
                <Form onClose={onClose} issueDetails={issueDetails} onSave={onSave} />
            </Modal>
        </>
    );
};

export default CloseIssue;